import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class TopComponent extends Component {

    render() {
        return (
            <>
                <div className="top">
                    <Link to={this.props.path} className="btn-style-3 mb-3">
                        {(this.props.direction === 'back') ?
                            <><i className="fa fa-arrow-left" aria-hidden="true"></i>{'  ' + this.props.label}</>
                            :
                            <>{this.props.label}<i className="fa fa-arrow-right" aria-hidden="true"> </i></>
                        }
                    </Link>
                </div >
            </>
        );
    }
}

export default TopComponent;